import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import styles from "./OurProjects.module.scss";

function OurProjects() {
  const carouselResponsive = {
    0: {
      items: 1,
      slideBy: 1,
    },
    576: {
      items: 1,
      slideBy: 1,
    },
    768: {
      items: 2,
      slideBy: 2,
    },
    992: {
      items: 3,
      slideBy: 3,
    },
    1200: {
      items: 3,
      slideBy: 3,
    },
  };
  function padDigits(number, digits) {
    return (
      Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
    );
  }

  var loop = false;
  const counter = (event) => {
    var items = event.item.count;
    var slideBy = event.page.size;

    var indexCount = 2;
    if (slideBy == 1) {
      indexCount = 1;
    }

    if (loop == true) {
      var item = event.item.index - 2;
    } else {
      var item = event.item.index + indexCount;
    }

    // it loop is true then reset counter from 1
    if (item > items) {
      item = item - items;
    }

    item = Math.ceil(item / slideBy);
    items = Math.ceil(items / slideBy);

    $(".owl-dots").html(padDigits(item, 2) + " / " + padDigits(items, 2));
  };
  return (
    <section
      className={`${styles["section"]} ${styles["section__projects"]} ${styles["__section_normal_tb_padding"]}`}
    >
      <div className={`${styles["container"]}`}>
        <div className={`${styles["container__row"]}`}>
          <div className={`${styles["container__col_xs_12"]}`}>
            <h2 className={`${styles["container__heading"]}`}>Our Projects</h2>
            <div className={`${styles["container__row"]}`}>
              <div className={`${styles["container__col_md_7"]}`}>
                <p>
                  Our Projects We create one-of-a-kind, unique and interactive
                  digital experiences that are customized to each brand. We
                  propel your marketing vision with the right blend of
                  creativity and technology. Check out our recent projects with
                  Global Brands across the globe. Let's collaborate to build an
                  amazing digital experience.
                </p>
              </div>
            </div>
          </div>
          {typeof window !== "undefined" && OwlCarousel && (
            <OwlCarousel
              className={`${styles["owl_theme"]} ${styles["our_projects_carousel"]}`}
              margin={30}
              slideBy={"page"}
              autoplay={true}
              autoplayTimeout={6000}
              autoplaySpeed={1000}
              autoplayHoverPause={true}
              stagePadding={35}
              responsive={carouselResponsive}
              nav={true}
              dots={true}
              onInitialized={counter}
              onTranslated={counter}
            >
              <div className={`${styles["owl_carousel__item"]}`}>
                <img
                  className={`${styles["owl_carousel__image"]}`}
                  src="../../solutions/solutions/projects/medentika.png"
                  alt="Medentika - Digital Catalog"
                />
                <div className={`${styles["owl_carousel__content"]}`}>
                  <a
                    className={`${styles["owl_carousel__link"]} `}
                    // href="#modal"
                  >
                    <h5 className={`${styles["owl_carousel__heading"]}`}>
                      Medentika - Digital Catalog
                    </h5>
                  </a>
                  <p>
                    Large migration of PDF based brochures, catalogue of 100+
                    Products to Mobile App for offline consumption and better
                    readiblity.
                  </p>
                </div>
              </div>
              <div className={`${styles["owl_carousel__item"]}`}>
                <img
                  className={`${styles["owl_carousel__image"]}`}
                  src="../../solutions/solutions/projects/story-trails.png"
                  alt="Storytrails"
                />
                <div className={`${styles["owl_carousel__content"]}`}>
                  <a
                    className={`${styles["owl_carousel__link"]}`}
                    // href="#modal"
                  >
                    <h5 className={`${styles["owl_carousel__heading"]}`}>
                      Storytrails
                    </h5>
                  </a>
                  <p>
                    Location aware-app of high quality tours built once and
                    deployed across iOS and Android using ReactNative
                    technology.
                  </p>
                </div>
              </div>
              <div className={`${styles["owl_carousel__item"]}`}>
                <img
                  className={`${styles["owl_carousel__image"]}`}
                  src="../../solutions/solutions/projects/isb-executive.png"
                  alt="ISB - Executive Education"
                />
                <div className={`${styles["owl_carousel__content"]}`}>
                  <a
                    className={`${styles["owl_carousel__link"]}`}
                    // href="#modal"
                  >
                    <h5 className={`${styles["owl_carousel__heading"]}`}>
                      ISB - Executive Education
                    </h5>
                  </a>
                  <p>
                    New Executive Education designed, developed and lauched in
                    under 8 weeks on Adobe Experience Manager.
                  </p>
                </div>
              </div>
              <div className={`${styles["owl_carousel__item"]}`}>
                <img
                  className={`${styles["owl_carousel__image"]}`}
                  src="../../solutions/solutions/projects/ollmoo-future.png"
                  alt="Ollmoo - Future Women Leaders"
                />
                <div className={`${styles["owl_carousel__content"]}`}>
                  <a
                    className={`${styles["owl_carousel__link"]}`}
                    // href="#modal"
                  >
                    <h5 className={`${styles["owl_carousel__heading"]}`}>
                      Ollmoo - Future Women Leaders
                    </h5>
                  </a>
                  <p>
                    Portal for onboarding new recruits with a seamless marketing
                    to application experience.
                  </p>
                </div>
              </div>
            </OwlCarousel>
          )}
        </div>
      </div>
    </section>
  );
}

export default OurProjects;
